// Auth
export const LOGIN_URL = 'auth/sign-in';
export const GOOGLE_LOGIN_URL = 'auth/google';
export const LOGOUT_URL = 'auth/sign-out';
export const REGISTRATION_URL = 'auth/sign-up';
export const RESET_PASSWORD_URL = 'auth/reset-password';
export const ACTIVATE_ACCOUNT_URL = 'auth/activation-account';
export const SET_PASSWORD_URL = 'auth/set-password';

// Users
export const USERS_URL = 'users/with-role-user';
export const USER_PROFILE = 'users/profile';
export const UPDATE_USER_PROFILE = 'users/change-profile';

// Teachers
export const TEACHER_URL = 'teachers';
export const DISABLED_TEACHERS_URL = 'teachers/disabled';
export const TEACHERS_WITH_EMAIL_URL = 'teachers/with-email';
export const TEACHER_SCHEDULE_URL = 'schedules/full/teachers?semesterId=';
export const TEACHER_ACTIVE_SEMESTERS_SCHEDULE_URL = 'schedules/full/teachers/active?teacherId=';
export const FOR_TEACHER_SCHEDULE_URL = 'schedules/teacher';
export const LESSON_BY_TEACHER_URL = '/lessons/teacher';
export const MY_LESSONS_URL = 'lessons/teacher/my-lessons';

// Groups
export const GROUP_URL = 'groups';
export const GROUPS_URL = 'groups';
export const GROUPS_AFTER_URL = '/groups/after';
export const DISABLED_GROUPS_URL = 'groups/disabled';
export const MY_DEPARTMENT_GROUPS_URL = 'groups/my-department';
export const GROUPS_FOR_CURRENT_SCHEDULE = '/semesters/current/groups';

// Students
export const STUDENT_URL = 'students';
export const MOVE_STUDENTS_URL = 'students/move-to-group';
export const STUDENTS_TO_GROUP_FILE = 'students/import?groupId=';
export const WITH_STUDENTS = '/with-students';

// Rooms
export const ROOM_URL = 'rooms';
export const ROOM_AFTER_URL = 'rooms/after';
export const ROOM_ORDERED_URL = 'rooms/ordered';
export const ROOM_TYPES_URL = 'room-types';
export const DISABLED_ROOMS_URL = 'rooms/disabled';
export const ROOMS_AVAILABILITY = 'rooms/available';
export const BUSY_ROOMS = 'schedules/full/rooms';
export const COMBINED_BUSY_ROOMS_URL = 'schedules/full/rooms/active';

// Lessons
export const LESSON_URL = 'lessons';
export const LESSON_TYPES_URL = 'lessons/types';
export const COPY_LESSON_URL = '/lessons/copy-lesson-for-groups';
export const LESSONS_FROM_SEMESTER_COPY_URL = '/lessons/copy-lessons';
export const LESSON_FROM_CURRICULUM_URL = '/lessons/from-curriculum';

// Subjects
export const SUBJECT_URL = 'subjects';
export const DISABLED_SUBJECTS_URL = 'subjects/disabled';

// Semesters
export const SEMESTERS_URL = 'semesters';
export const CURRENT_SEMESTER_URL = 'semesters/current';
export const DEFAULT_SEMESTER_URL = 'semesters/default';
export const DISABLED_SEMESTERS_URL = 'semesters/disabled';
export const EXAM_SESSION_URL = 'semesters/exam-session';
export const ARCHIVE_SEMESTER = '/archive';
export const ARCHIVED_SEMESTERS_URL = '/archive/all-semesters';

// Schedules
export const SCHEDULE_ITEMS_URL = 'schedules';
export const SCHEDULE_SEMESTER_ITEMS_URL = 'schedules/semester';
export const SCHEDULE_BY_DATE_URL = 'schedules/by-date';
export const SCHEDULE_CHECK_AVAILABILITY_URL = 'schedules/data-before';
export const FULL_SCHEDULE_URL = 'schedules/full/semester?semesterId=';
export const GROUP_SCHEDULE_URL = 'schedules/full/groups?semesterId=';
export const GROUP_SCHEDULE_CALENDAR_URL = 'schedules/full/groups/calendar';
export const TEACHER_SCHEDULE_CALENDAR_URL = 'schedules/full/teachers/calendar';
export const LESSON_SCHEDULE_CALENDAR_URL = 'schedules/full/lessons/calendar';
export const SEMESTER_COPY_URL = '/schedules/copy-schedule';
export const CLEAR_SCHEDULE_URL = '/schedules/delete-schedules';
export const SCHEDULE_ITEM_ROOM_CHANGE = '/schedules/by-room';
export const EXPORT_SCHEDULE_XLSX_URL = 'schedules/export/xlsx?semesterId=';
export const TEACHER_ACTIVE_SCHEDULE_CALENDAR_URL = 'schedules/full/teachers/active/calendar';

// Classes
export const CLASS_URL = 'classes';

// Departments
export const DEPARTMENT_URL = 'departments';

//Curriculum
export const CURRICULUM_URL = '/curriculum-entries';
export const CURRICULUM_COPY_URL = '/curriculum-entries/copy';

// Public
export const PUBLIC_CLASSES_URL = 'public/classes';
export const PUBLIC_TEACHER_URL = 'public/teachers';
export const PUBLIC_SEMESTERS_URL = 'public/semesters';

// Downloads & Email
export const SEND_PDF_TO_EMAIL = 'send-pdf-to-email';
export const PUBLIC_DOWNLOAD_GROUP_SCHEDULE_URL = 'download/schedule-for-group-in-pdf';
export const PUBLIC_DOWNLOAD_TEACHER_SCHEDULE_URL = 'download/schedule-for-teacher-in-pdf';
